<mprd-priceplan-details-skeleton *ngIf="fetching"></mprd-priceplan-details-skeleton>
<section *ngIf="!fetching" class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-tit1-sp rs-txt-c2 rs-has-subtit">
            {{ 'mobile.pricingPlan.myPricingPlan.title' | translate }}
          </h1>
          <p class="rs-txt-s5 rs-txt-c2 small-only-text-center" x-ms-format-detection="none">
            <mprd-access-number-formatter
              [accessNumber]="selectedProduct?.accessNumber"
              [plc]="selectedProduct?.plc"
            ></mprd-access-number-formatter>
          </p>

          <div class="panel rs-panel-big clearfix">
            <div
              class="rs-msgbox rs-msgbox-info"
              data-alert=""
              aria-live="assertive"
              role="alertdialog"
              *ngIf="isADeeplink()"
            >
              <div class="rs-msgbox-title">
                {{ 'mobile.priceplan.information.promo.title' | translate }}
              </div>
              <div class="rs-msgbox-content">
                <p>
                  {{ 'mobile.priceplan.information.promo.description' | translate }}
                </p>
              </div>
              <div class="rs-msgbox-icon">
                <i class="icon-Information-box" aria-hidden="true"></i>
              </div>
            </div>

            <div
              class="rs-msgbox rs-msgbox-warning"
              data-alert=""
              aria-live="assertive"
              role="alertdialog"
              *ngIf="displayPendingOrderAlert"
            >
              <div class="rs-msgbox-title">
                {{ 'mobile.priceplan.pending.order.title' | translate }}
              </div>
              <div class="rs-msgbox-content">
                <p>
                  {{ 'mobile.priceplan.pending.order.description' | translate }}
                </p>
              </div>
              <div class="rs-msgbox-icon">
                <i class="icon-Warning-box" aria-hidden="true"></i>
              </div>
            </div>

            <!-- Active Plan Section -->
            <h2 class="rs-tit3" *ngIf="!hasError && activeSubscription">
              {{ 'mobile.priceplan.activeplan' | translate }}
            </h2>

            <div id="currentPricingPlan" class="row">
              <div class="columns small-12 medium-6">
                <div class="panel rs-bg-grey1 rs-no-margin rs-no-radius-bottom">
                  <div class="rs-flex-row rs-flex-bottom">
                    <div class="rs-flex-column">
                      <p class="rs-txt-s5 rs-txt-purple rs-font-pxB">
                        {{ activeSubscription?.productName | mprdTranslate }}
                      </p>
                    </div>
                    <div class="rs-flex-column rs-flex-shrink">
                      <p class="rs-txt-success rs-font-pxB">
                        <i class="icon-Status-ok rs-margin-right1" aria-hidden="true"></i
                        >{{ 'mobile.pricingPlan.actualPlan' | translate }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="panel rs-bg-grey2 rs-no-radius-top">
                  <p class="rs-txt-s6 rs-font-pxB">
                    {{ activeSubscription?.computeCharacteristics?.data }}
                  </p>
                  <p class="rs-font-pxB rs-padding-bottom1">
                    {{ activeSubscription?.computeCharacteristics?.calls }}
                  </p>
                  <p class="rs-font-pxB rs-padding-bottom1">
                    {{ activeSubscription?.computeCharacteristics?.sms }}
                  </p>
                  <p *ngIf="activeSubscription?.freeText1" class="rs-font-pxB rs-padding-bottom1">
                    {{ activeSubscription.freeText1[languageService.getSelectedLanguage()] }}
                  </p>
                  <p *ngIf="activeSubscription?.freeText2" class="rs-font-pxB rs-padding-bottom1">
                    {{ activeSubscription.freeText2[languageService.getSelectedLanguage()] }}
                  </p>
                  <div
                    class="rs-flex-row rs-flex-middle"
                    *ngIf="
                      activeSubscription?.computeCharacteristics?.favapp === 'mob_fullc_bizzm' &&
                      activeFavApp &&
                      activeFavApp.optionCodeForDescription
                    "
                  >
                    <div class="rs-flex-columns">
                      <p class="rs-font-pxB">
                        {{ 'mobile.pricingPlan.myPricingPlan.yourFavApp' | translate }}
                      </p>
                    </div>
                    <span>
                      <div *ngIf="activeFavApp" class="rs-flex-columns">
                        <img
                          class="rs-maxh-s3"
                          [src]="activeFavApp.iconLocation"
                          alt="{{ activeFavApp.name }}"
                          draggable="false"
                          unselectable="on"
                          style="user-select: none"
                        />
                      </div>
                    </span>
                  </div>
                  <div
                    class="rs-flex-row rs-flex-middle"
                    *ngIf="activeSubscription?.computeCharacteristics?.favapp !== 'mob_fullc_bizzm'"
                  >
                    <div class="rs-flex-columns">
                      <span
                        class="rs-sbox-block rs-font-pxB rs-padding-bottom1"
                        *ngIf="activeSubscription?.computeCharacteristics?.favapp === 'epic_beats'"
                        [innerHTML]="'mobile.priceplan.epicbeats' | translate"
                      ></span>
                      <span
                        class="rs-sbox-block rs-font-pxB rs-padding-bottom1"
                        *ngIf="
                          activeSubscription?.computeCharacteristics?.favapp === 'epic_stories'
                        "
                        [innerHTML]="'mobile.priceplan.epicstories' | translate"
                      ></span>
                      <span
                        class="rs-sbox-block rs-font-pxB rs-padding-bottom1"
                        *ngIf="activeSubscription?.computeCharacteristics?.favapp === 'epic_videos'"
                        [innerHTML]="'mobile.priceplan.epicvideos' | translate"
                      ></span>
                    </div>
                  </div>
                  <div class="rs-flex-row rs-flex-bottom">
                    <div *ngIf="activeSubscription?.price" class="rs-flex-column">
                      <p class="rs-txt-purple rs-font-pxB">
                        {{ 'mobile.pricingPlan.monthlyPrice' | translate }}
                      </p>
                    </div>
                    <div class="rs-flex-column rs-flex-shrink">
                      <p *ngIf="activeSubscription?.price">
                        <px-currency-amount
                          [amountClass]="'rs-price-s'"
                          [amount]="getPricePlanPrice(activeSubscription)"
                        ></px-currency-amount>
                        <span class="rs-period rs-price-m">{{
                          activeSubscription?.price | chargeFrequency: 'chargeFrequency'
                        }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="rs-me"></div>

            <!-- Alternative Plans -->
            <h2 class="rs-tit3">
              {{ 'mobile.priceplan.alternativeplans' | translate }}
            </h2>

            <!-- Switch fullControl filter -->
            <div
              id="fullControlButton"
              *ngIf="availableSubscriptions && availableSubscriptions.length > 0 && hasFullControl"
              class="rs-flex-row rs-flex-middle"
            >
              <div class="rs-flex-columns">
                <label for="fullControlSwitch" id="ac-switch-text"
                  ><span id="fullControlLabel" class="rs-block rs-font-pxB">{{
                    'mobile.priceplan.fullcontrol' | translate
                  }}</span></label
                >
              </div>
              <div class="rs-flex-columns rs-flex-grow">
                <div class="rs-switch">
                  <input
                    type="checkbox"
                    id="fullControlSwitch"
                    name="switch1"
                    (change)="toggleFullControl()"
                  />
                  <label for="fullControlSwitch">
                    <span class="rs-switch-active" aria-hidden="true">{{
                      'mobile.priceplan.yes' | translate
                    }}</span>
                    <span class="rs-switch-inactive" aria-hidden="true">{{
                      'mobile.priceplan.no' | translate
                    }}</span>
                  </label>
                </div>
              </div>
            </div>

            <px-alert [alertKey]="'priceplandetailsalert'"></px-alert>

            <!-- Available Subscriptions List -->
            <div id="availablePricingPlans" class="rs-flex-row rs-sbox-highlight">
              <div
                *ngFor="
                  let pricePlan of availableSubscriptions | fullControl: fullControl;
                  let i = index
                "
                class="rs-flex-columns small-12 medium-6 rs-order-m1"
              >
                <div
                  data-tms-event="card-click-impression"
                  data-tms-card-zone="alternative plans"
                  attr.data-tms-card-name="{{ pricePlan.productName | mprdTranslate }}"
                  attr.data-tms-context="{{ pricePlan.mpcUuid }}"
                  attr.data-tms-product="{{ jsonProduct }}"
                  data-tms-noclick
                >
                  <div
                    class="rs-sbox rs-sbox-highlighted"
                    style="min-height: 330px"
                    (click)="updateSelectedRadio(i)"
                    data-tms-noclick
                  >
                    <input
                      id="radio{{ i }}"
                      type="radio"
                      name="radioSbox"
                      aria-controls="confirm-2"
                      [checked]="isPlanSelected(i)"
                    />
                    <label for="radio{{ i }}">
                      <ng-container *ngIf="isRecommendedPlan(pricePlan?.mpcUuid)">
                        <span class="rs-sbox-highlighted-txt-container">
                          <span class="rs-sbox-highlighted-txt">
                            {{ 'mobile.priceplan.recommended' | translate }}</span
                          >
                        </span>
                      </ng-container>
                      <span class="rs-sbox-maincontent">
                        <span class="rs-sbox-check-header">
                          <span class="rs-sbox-check"></span>
                          <span class="rs-sbox-check-content">
                            <span class="rs-sbox-title">
                              <span class="rs-flex-column">
                                <span class="rs-txt-s5 rs-txt-purple rs-font-pxB">
                                  {{ pricePlan.productName | mprdTranslate }}
                                </span>
                              </span>
                              <ng-container *ngIf="fivegArray[pricePlan?.mpcUuid]">
                                <span class="rs-flex-column rs-flex-shrink">
                                  <img
                                    class="rs-h-s2"
                                    alt="5G"
                                    src="{{ 'mobile.pricingPlan.fivegIcon' | translate }}"
                                  />
                                </span>
                              </ng-container>
                            </span>
                          </span>
                        </span>
                        <span class="rs-txt-s6 rs-font-pxB rs-block">{{
                          pricePlan?.computeCharacteristics?.data
                        }}</span>
                        <span class="rs-sbox-block rs-font-pxB rs-padding-bottom1">
                          {{ pricePlan?.computeCharacteristics?.calls }}
                        </span>
                        <span class="rs-sbox-block rs-font-pxB rs-padding-bottom1">{{
                          pricePlan?.computeCharacteristics?.sms
                        }}</span>
                        <span
                          *ngIf="pricePlan?.freeText1"
                          class="rs-sbox-block rs-font-pxB rs-padding-bottom1"
                          >{{ pricePlan.freeText1[languageService.getSelectedLanguage()] }}</span
                        >
                        <span
                          *ngIf="pricePlan?.freeText2"
                          class="rs-sbox-block rs-font-pxB rs-padding-bottom1"
                          >{{ pricePlan.freeText2[languageService.getSelectedLanguage()] }}</span
                        >
                        <ng-container
                          *ngIf="pricePlan?.computeCharacteristics?.favapp === 'mob_fullc_bizzm'"
                        >
                          <span class="rs-sbox-block rs-font-pxB rs-padding-bottom1">{{
                            'mobile.priceplan.favoriteapp' | translate
                          }}</span>
                          <span
                            class="rs-flex-row rs-flex-middle rs-flex-collapse rs-justify-center-small-only"
                          >
                            <span *ngIf="activeFavApp" class="rs-flex-columns">
                              <img
                                [src]="activeFavApp.iconLocation"
                                alt="{{ activeFavApp.name }}"
                                class="rs-maxh-s3 rs-maxh-m4 rs-margin-right1"
                              />
                            </span>
                          </span>
                        </ng-container>
                        <ng-container
                          *ngIf="pricePlan?.computeCharacteristics?.favapp !== 'mob_fullc_bizzm'"
                        >
                          <span
                            class="rs-sbox-block rs-font-pxB rs-padding-bottom1"
                            *ngIf="pricePlan?.computeCharacteristics?.favapp === 'epic_beats'"
                            [innerHTML]="'mobile.priceplan.epicbeats' | translate"
                          ></span>
                          <span
                            class="rs-sbox-block rs-font-pxB rs-padding-bottom1"
                            *ngIf="pricePlan?.computeCharacteristics?.favapp === 'epic_stories'"
                            [innerHTML]="'mobile.priceplan.epicstories' | translate"
                          ></span>
                          <span
                            class="rs-sbox-block rs-font-pxB rs-padding-bottom1"
                            *ngIf="pricePlan?.computeCharacteristics?.favapp === 'epic_videos'"
                            [innerHTML]="'mobile.priceplan.epicvideos' | translate"
                          ></span>
                        </ng-container>
                        <ng-container *ngIf="showMoreInfoCTA(pricePlan.mpcUuid)">
                          <span class="rs-sbox-block rs-padding-bottom3">
                            <button
                              [attr.data-reveal-id]="modalId"
                              class="rs-link rs-btn-no-style"
                              (click)="
                                openMoreInfoModal(pricePlan.mpcUuid); $event.stopPropagation()
                              "
                              data-tms-link-name="more info"
                              data-cy="more-info-popup"
                            >
                              {{ 'mobile.priceplan.moreInfo' | translate }}
                              <i aria-hidden="true" class="icon-Information-box icon-lh"></i>
                            </button>
                          </span>
                        </ng-container>
                      </span>
                      <span *ngIf="pricePlan?.price" class="rs-flex-row rs-flex-middle">
                        <span class="rs-flex-columns rs-flex-grow"
                          ><span class="rs-block rs-txt-purple rs-font-pxB">{{
                            'mobile.pricingPlan.monthlyPrice' | translate
                          }}</span></span
                        >

                        <span class="rs-flex-columns">
                          <p *ngIf="pricePlan?.price">
                            <px-currency-amount
                              [amountClass]="'rs-price-s'"
                              [amount]="getPricePlanPrice(pricePlan)"
                            ></px-currency-amount>
                            <span class="rs-period rs-price-m">{{
                              pricePlan?.price | chargeFrequency: 'chargeFrequency'
                            }}</span>
                          </p>
                        </span>
                      </span>
                    </label>
                  </div>
                  <!-- Button -->
                  <mprd-order-button
                    [ngClass]="{ hide: !isPlanSelected(i) }"
                    [(orderDisabled)]="orderButtonsDisabled"
                    [selectedProduct]="selectedProduct"
                    [option]="pricePlan"
                    (resultEmit)="onResult($event)"
                    [isSwap]="true"
                    [isBelfiusPartner]="isBelfiusPartner"
                    [packMpcUuid]="packMpcUuid"
                    [promoCode]="promoCode"
                  ></mprd-order-button>
                </div>
              </div>
            </div>

            <!-- Price information -->
            <small
              *ngIf="availableSubscriptions && availableSubscriptions.length > 0"
              class="rs-txt-s2 rs-block"
              >{{ 'mobile.pricingPlan.footer.information.label' | translate }}</small
            >

            <ng-container *ngIf="!availableSubscriptions || availableSubscriptions.length === 0">
              <div *ngIf="!isBelfiusPartner" id="contactUs">
                <ng-container *ngIf="isUnavailableSubscriptionFlexPackLink; else noPlanLink">
                  <a
                    href="{{ 'mobile.pricingPlan.noAvailableFlexPackLink' | translate }}"
                    target="_blank"
                    data-tms-link-name="change subscription"
                    data-cy="no-available-subscription-flex-pack"
                  >
                    {{ 'mobile.pricingPlan.noAvailableFlexPackLabel' | translate }}
                    <span
                      class="rs-icon-link-tb"
                      title="{{ 'mobile.pricingPlan.noAvailableFlexPackLabel' | translate }}"
                    >
                      <span class="show-for-sr">
                        {{ 'mobile.pricingPlan.noAvailableFlexPackLabel' | translate }}
                      </span>
                    </span>
                  </a>
                </ng-container>
                <ng-template #noPlanLink>
                  <a
                    href="{{ 'mobile.pricingPlan.noPlanLink' | translate }}"
                    target="_blank"
                    data-tms-link-name="change subscription"
                    data-cy="no-available-plan"
                    >{{ 'mobile.pricingPlan.noPlanLabel' | translate
                    }}<span
                      class="rs-icon-link-tb"
                      title="{{ 'mobile.pricingPlan.noPlanLabel' | translate }}"
                      ><span class="show-for-sr">{{
                        'mobile.pricingPlan.noPlanLabel' | translate
                      }}</span></span
                    ></a
                  >
                </ng-template>
                <div class="rs-me"></div>
              </div>
              <div *ngIf="isBelfiusPartner" id="contactUsBelfiusPartner">
                <a
                  href="{{ 'mobile.pricingPlan.belfiusPartnerLink' | translate }}"
                  target="_blank"
                  data-tms-link-name="change subscription"
                  >{{ 'mobile.pricingPlan.belfiusPartnerLabel' | translate
                  }}<span
                    class="rs-icon-link-tb"
                    title="{{ 'mobile.pricingPlan.belfiusPartnerLabel' | translate }}"
                    ><span class="show-for-sr">{{
                      'mobile.pricingPlan.belfiusPartnerLabel' | translate
                    }}</span></span
                  ></a
                >
                <div class="rs-me"></div>
              </div>
            </ng-container>

            <!-- Specific Conditions -->
            <div
              id="specificConditions"
              class="row"
              *ngIf="availableSubscriptions && isSECustomer()"
            >
              <div class="columns small-12">
                <div
                  class="rs-accordion-panel rs-border jsrs-accordion-panel"
                  (click)="toggleSpecificConditionsExpanded()"
                >
                  <a href="javascript:void(0)" class="rs-accordion-title rs-expanded"
                    ><span class="rs-accordion-title-txt">{{
                      'mobile.pricingPlan.swap.plan.conditions' | translate
                    }}</span
                    ><i
                      class="icon-Arrow-down icon-lh rs-accordion-arrow"
                      [ngClass]="{
                        'icon-rotate-180': isSpecificConditionsExpanded
                      }"
                    ></i
                  ></a>
                  <div
                    class="rs-accordion-content"
                    [ngStyle]="{
                      display: isSpecificConditionsExpanded ? 'block' : 'none'
                    }"
                  >
                    <div class="row">
                      <div class="small-12 medium-6 columns">
                        <p class="rs-font-pxB">
                          {{ 'mobile.pricingPlan.swap.plan.bizzInternational' | translate }}
                        </p>

                        <p>
                          {{ 'mobile.pricingPlan.swap.plan.rates.description' | translate }}
                        </p>
                        <p
                          [innerHTML]="'mobile.pricingPlan.swap.plan.rates.list' | translate: true"
                        ></p>
                      </div>

                      <div class="small-12 medium-6 columns">
                        <p class="rs-font-pxB">
                          {{ 'mobile.pricingPlan.swap.plan.unlimitedData.description' | translate }}
                        </p>

                        <p
                          [innerHTML]="
                            'mobile.pricingPlan.swap.plan.unlimitedData.text' | translate: true
                          "
                        ></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rs-le2"></div>
        </div>
      </div>
    </section>
  </main>
</section>
